import { render, staticRenderFns } from "./moreCS.vue?vue&type=template&id=3c868892&lang=pug&"
import script from "./moreCS.vue?vue&type=script&lang=js&"
export * from "./moreCS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports